import { useEffect, useRef } from "react";

const CELL = 16;
const CHARS = "PICKLEBULPEN01<>+*/#$%&@!?".split("");

export default function MatrixRain() {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf, cols, drops, w, h, mask, mw, mh;
    const buildMask = () => {
      mw = Math.ceil(w / CELL); mh = Math.ceil(h / CELL);
      const m = document.createElement("canvas");
      m.width = mw; m.height = mh;
      const mc = m.getContext("2d");
      mc.fillStyle = "#000"; mc.fillRect(0, 0, mw, mh);
      mc.strokeStyle = "#fff"; mc.fillStyle = "#fff";
      const cx = mw * 0.72, cy = mh * 0.42, r = Math.min(mw, mh) * 0.3;
      mc.lineWidth = Math.max(2, r * 0.16);
      mc.beginPath(); mc.arc(cx, cy, r, 0, Math.PI * 2); mc.stroke();
      const hr = Math.max(1.3, r * 0.1);
      for (let a = 0; a < 12; a++) {
        const ang = (a / 12) * Math.PI * 2, rr = r * 0.55;
        mc.beginPath(); mc.arc(cx + Math.cos(ang) * rr, cy + Math.sin(ang) * rr, hr, 0, Math.PI * 2); mc.fill();
      }
      mc.beginPath(); mc.arc(cx, cy, hr, 0, Math.PI * 2); mc.fill();
      const ny = Math.floor(mh * 0.82);
      mc.lineWidth = 1.4;
      mc.beginPath(); mc.moveTo(0, ny + 0.5); mc.lineTo(mw, ny + 0.5); mc.stroke();
      for (let x = 1; x < mw; x += 3) { mc.beginPath(); mc.moveTo(x + 0.5, ny - 3); mc.lineTo(x + 0.5, ny); mc.stroke(); }
      return mc.getImageData(0, 0, mw, mh).data;
    };
    const setup = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
      cols = Math.ceil(w / CELL);
      drops = Array.from({ length: cols }, () => Math.random() * -(h / CELL));
      mask = buildMask();
      ctx.fillStyle = "#030603"; ctx.fillRect(0, 0, w, h);
    };
    const inMask = (col, row) => {
      if (row < 0 || row >= mh || col < 0 || col >= mw) return false;
      return mask[(row * mw + col) * 4] > 120;
    };
    let last = 0;
    const frame = (t) => {
      raf = requestAnimationFrame(frame);
      if (t - last < 50) return;
      last = t;
      ctx.fillStyle = "rgba(3,6,3,0.12)";
      ctx.fillRect(0, 0, w, h);
      ctx.font = `${CELL - 3}px monospace`;
      for (let i = 0; i < cols; i++) {
        const row = Math.floor(drops[i]);
        const ch = CHARS[(Math.random() * CHARS.length) | 0];
        const hot = inMask(i, row);
        if (hot) { ctx.fillStyle = "#D9F99D"; ctx.shadowColor = "#A3E635"; ctx.shadowBlur = 8; }
        else { ctx.fillStyle = "rgba(34,197,94,0.8)"; ctx.shadowBlur = 0; }
        ctx.fillText(ch, i * CELL, row * CELL);
        ctx.shadowBlur = 0;
        if (row * CELL > h && Math.random() > 0.975) drops[i] = Math.random() * -20;
        else drops[i] += hot ? 0.55 : 1;
      }
    };
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setup();
    if (!reduced) raf = requestAnimationFrame(frame);
    const onResize = () => setup();
    window.addEventListener("resize", onResize);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", onResize); };
  }, []);
  return (
    <div className="fixed inset-0 z-0 pointer-events-none" data-testid="matrix-rain-bg">
      <canvas ref={ref} className="w-full h-full" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/70" />
    </div>
  );
}
